<template>
	<vxe-modal :loading="loading" v-model="modal" width="800" height="500" @show="show" :title="title" destroy-on-close
		:showFooter="true">
		<template #default>
			<div class="full" style="box-sizing: border-box;padding: 10px;overflow: hidden;">

				<div class="full" ref="imgContent"
					style="text-align: center;background-color: white;box-sizing: border-box;padding: 10px;height: auto;">
					<h1>{{content.data.title}}</h1>
					<table border style="width: 100%;text-align: center;color: black;font-size: 14px;">
						<tr>
							<th style="width: 50px;">序号</th>
							<th>编码</th>
							<th>名称</th>
							<th>规格</th>
							<th>数量</th>
							<th>单位</th>
							<th>单价</th>
							<th>金额</th>
						</tr>
						<tr v-for="(item,index) in content.data.detail" :key="index">
							<td>{{index+1}}</td>
							<td>{{item.code}}</td>
							<td>{{item.name}}</td>
							<td>{{item.model}}</td>
							<td>{{item.size}}</td>
							<td>{{item.unit}}</td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td>总金额</td>
							<td colspan="7"></td>
						</tr>
					</table>
					<h3>{{content.data.footer}}</h3>
					<h3>{{content.data.notice}}</h3>
				</div>

				<div class="full" style="background-color: white;padding: 10px;box-sizing: border-box;">
					<div class="full" style="position: relative;">
						<el-form ref="form" :model="form" label-width="100px" size="mini">
							<el-form-item label="供应商">
								<el-input readonly v-model="form.supplier"></el-input>
							</el-form-item>
							<!-- 				<el-form-item required label="收货方式" >
								<el-select v-model="form.deliverytype" placeholder="">
									<el-option label="物流" :value="0"></el-option>
									<el-option label="自提" :value="1"></el-option>
									<el-option label="送货上门" :value="2"></el-option>
								</el-select>
							</el-form-item> -->
							<el-form-item required label="内容">
								<el-input v-model="form.content" type="textarea" :rows="10"></el-input>
							</el-form-item>
							<el-form-item label="发送类型">
								<el-radio-group v-model="form.contenttype">
									<el-radio label="text">文本</el-radio>
									<el-radio label="img">图片</el-radio>
									<el-radio label="excle">Excle</el-radio>
								</el-radio-group>
								<!-- 								<el-switch v-model="form.content2img" active-text="是" inactive-text="否">
								</el-switch> -->
							</el-form-item>
							<el-form-item label="发送测绘图">
								<el-switch v-model="form.modelimg" @change="modelimgChange" active-text="是"
									inactive-text="否">
								</el-switch>
							</el-form-item>
						</el-form>
					</div>
				</div>
			</div>
		</template>
		<template #footer>
			<vxe-button status="success" content="复制" @click="copy"></vxe-button>
			<vxe-button status="primary" content="发送" @click="send"></vxe-button>
		</template>
	</vxe-modal>
</template>
<style scoped>

</style>
<script>
	import html2canvas from 'html2canvas';
	export default {
		props: {
			componentStore: {
				default: () => {
					return null
				}
			},
			row: {
				default: () => {
					return []
				}
			},
			detail: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				modal: false,
				loading: false,
				tableData: [],
				title: '报货话术',
				content: null,
				file: null,
				form: {
					content: '',
					contenttype: 'text',
					deliverytype: '',
					suppliername: null,
					modelimg: false
				},
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			init() {

			},
			cancel() {
				this.modal = false
			},
			hide() {
				this.$emit('hide')
			},
			show() {

			},
			modalShow() {
				this.form = {
					content: '',
					contenttype: 'text',
					deliverytype: '',
					suppliername: null,
					modelimg: false
				}
				this.getcontent()
				this.modal = true
			},
			modelimgChange() {
				this.getcontent()
			},

			getcontent() {
				this.title = '报价话术【' + this.row.billCode + '】'
				this.form.supplier = this.row.supplierName
				// console.log(this.form.modelimg)
				this.content = this.componentStore.getcontent(this.row, this.detail, 'reportgoods', this.form.modelimg)
				// console.log(this.content)
				this.form.content = this.content.text
			},
			async createimg() {
				return new Promise((reslove) => {
					html2canvas(this.$refs.imgContent, {
						scale: 1,
						useCORS: true,
						scrollY: -100000
					}).then((canvas) => {
						this.form.file = canvas.toDataURL('img/png', 1)
						reslove()
						//this.loading = false
					})
				})
			},
			async send() {
				if(!this.row){
					this.$message.error('未选择明细')
					return
				}
				// await this.createimg()
				if (!this.form.content) {
					this.$message.error('请输入内容')
					return
				}
				this.loading = true
				if (this.form.contenttype == 'img') {
					await this.createimg()
				}
				
				this.$api.wlnpurchase.reportgoods({
					data: this.detail,
					billCode:this.row.billCode,
					content: this.form.content,
					contenttype: this.form.contenttype,
					supplierid: this.row.supplierID,
					json: this.content,
					file: this.form.file,
					type: 'send',
					action: 'report'
				}).then(() => {
					this.loading = false
					this.$message.success('发送成功')
					// this.componentStore.customreload()
				}, () => {
					this.loading = false
				})
			},
			copy() {
				if (!this.form.content) {
					this.$message.error('请输入内容')
					return
				}
				this.$copyText(this.form.content).then(() => {
					this.$api.wlnpurchase.reportgoods({
						data: this.detail,
						supplierid: this.row.supplierID,
						type: 'copy',
						action: 'report'
					}).then(() => {
						this.$message.success('复制成功')
						// this.componentStore.customreload()
					})
				}, () => {
					this.$message.success('复制失败')
				})
			}


		},
		components: {

		}
	}
</script>